






export default {
  name: 'game-large-image'

  props: ['image']
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/game/GameLargeImage.vue